<script setup lang="ts">
import { computed } from 'vue';
import { IonCol, IonRow } from '@ionic/vue';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { STORIES_CONFIG } from '@/constants';
import type { Story } from '@/types/stories';

interface Props {
  story: Story | null;
  swiperRef: any;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  swiper: [swiperInstance: any];
}>();

const modules = [Pagination];

const shouldLoop = computed(() => {
  return (
    (props.story?.children?.length || 0) > STORIES_CONFIG.SWIPER_LOOP_THRESHOLD
  );
});

const handleSwiper = (swiperInstance: any) => {
  emit('swiper', swiperInstance);
};
</script>

<template>
  <ion-row class="slider slider-row stories-slider">
    <ion-col
      class="controls-col"
      size="12"
    >
      <div class="slider-controls">
        <div class="stories-swiper-pagination"></div>
      </div>
    </ion-col>
    <ion-col
      class="slider-col"
      size="12"
    >
      <swiper
        class="slider-swiper"
        :modules="modules"
        :slides-per-view="1"
        :centered-slides="true"
        :loop="shouldLoop"
        :space-between="0"
        :speed="STORIES_CONFIG.SWIPER_TRANSITION_SPEED_MS"
        :pagination="{ el: '.stories-swiper-pagination', clickable: true }"
        @swiper="handleSwiper"
      >
        <swiper-slide
          v-for="(item, i) in story?.children"
          :key="item.id"
          class="slider-slide"
        >
          <slot
            name="slide"
            :item="item"
            :index="i"
          />
        </swiper-slide>
      </swiper>
    </ion-col>
  </ion-row>
</template>

<style lang="less" scoped>
.slider-row {
  .controls-col {
    height: 40px;
    padding: 0 var(--base-gap);
  }

  .slider-col {
    padding: 0 var(--base-gap);
  }
}

.slider-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--gap-xs);
  margin-top: var(--gap-xs);

  .stories-swiper-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
</style>
